@if (displayMerged()) {
<div class="floori-label-items-wrapper">
    @for (item of validLabels(); track item.label) {
    <div class="floori-label-item" [ngStyle]="{ 'background-color': item.bgColor }">
        @if (item.icon) {
        <div class="floori-label-item-icon">
            <floori-icon
                class="floori-icon"
                [name]="item.icon.large ?? ''"
                [ngStyle]="{ color: item.color ?? 'var(--fl-white)' }"></floori-icon>
        </div>
        }
        <span class="floori-label-item-text" [ngStyle]="{ color: item.color ?? 'var(--fl-white)' }">
            {{ item.label | flTranslate }}
        </span>
    </div>
    }
</div>
} @else { @if (labelsTopLeft().length) {
<div class="floori-label-items-wrapper top-left">
    @for (item of labelsTopLeft(); track item.label) {
    <div class="floori-label-item" [ngStyle]="{ 'background-color': item.bgColor }">
        @if (item.icon) {
        <div class="floori-label-item-icon">
            <floori-icon
                class="floori-icon"
                [name]="item.icon.large ?? ''"
                [ngStyle]="{ color: item.color ?? 'var(--fl-white)' }"></floori-icon>
        </div>
        }
        <span class="floori-label-item-text" [ngStyle]="{ color: item.color ?? 'var(--fl-white)' }">
            {{ item.label | flTranslate }}
        </span>
    </div>
    }
</div>
} @if (labelsTopRight().length) {
<div class="floori-label-items-wrapper top-right">
    @for (item of labelsTopRight(); track item.label) {
    <div class="floori-label-item" [ngStyle]="{ 'background-color': item.bgColor }">
        @if (item.icon) {
        <div class="floori-label-item-icon">
            <floori-icon
                class="floori-icon"
                [name]="item.icon.large ?? ''"
                [ngStyle]="{ color: item.color ?? 'var(--fl-white)' }"></floori-icon>
        </div>
        }
        <span class="floori-label-item-text" [ngStyle]="{ color: item.color ?? 'var(--fl-white)' }">
            {{ item.label | flTranslate }}
        </span>
    </div>
    }
</div>
} @if (labelsBottomLeft().length) {
<div class="floori-label-items-wrapper bottom-left">
    @for (item of labelsBottomLeft(); track item.label) {
    <div class="floori-label-item" [ngStyle]="{ 'background-color': item.bgColor }">
        @if (item.icon) {
        <div class="floori-label-item-icon">
            <floori-icon
                class="floori-icon"
                [name]="item.icon.large ?? ''"
                [ngStyle]="{ color: item.color ?? 'var(--fl-white)' }"></floori-icon>
        </div>
        }
        <span class="floori-label-item-text" [ngStyle]="{ color: item.color ?? 'var(--fl-white)' }">
            {{ item.label | flTranslate }}
        </span>
    </div>
    }
</div>
} @if (labelsBottomRight().length) {
<div class="floori-label-items-wrapper bottom-right">
    @for (item of labelsBottomRight(); track item.label) {
    <div class="floori-label-item" [ngStyle]="{ 'background-color': item.bgColor }">
        @if (item.icon) {
        <div class="floori-label-item-icon">
            <floori-icon
                class="floori-icon"
                [name]="item.icon.large ?? ''"
                [ngStyle]="{ color: item.color ?? 'var(--fl-white)' }"></floori-icon>
        </div>
        }
        <span class="floori-label-item-text" [ngStyle]="{ color: item.color ?? 'var(--fl-white)' }">
            {{ item.label | flTranslate }}
        </span>
    </div>
    }
</div>
} }
